// extracted by mini-css-extract-plugin
module.exports = {"scrollListPill":"ShelveScrollList__scrollListPill","removeFromShelve":"ShelveScrollList__removeFromShelve","addToShelve":"ShelveScrollList__addToShelve"};